import { css } from 'styled-components';
import { colors } from '../../abstracts';
export const transitionDuration = '0.2s';
export const transitionTimingFunction = 'ease-in-out';
export const createTransition = ({
  properties,
  duration = transitionDuration,
  timingFunction = transitionTimingFunction
}) => css(["transition:", ";"], properties.map(property => `${property} ${duration} ${timingFunction}`).join(', '));
export const getStatusColor = property => ({
  success: colors.successDeeper,
  warning: property === 'color' ? colors.black : colors.warningBright,
  error: colors.errorDeep
});